export default "__VITE_ASSET__BXh_uG0a__"